<template>
  <!-- サイドメニュー -->
  <div class="main-menu disp-scroll" :style="{ width: width + 'px' }">
    <div class="resize-border" @mousedown="mouseDown"></div>
    <h3 class="menu-title">
      <p>
        <span class="mdi mdi-calendar-star" style="margin-right: 4px"></span>
        お気に入り
      </p>
      <button
        class="button"
        style="background: transparent; border: none; font-size: 15px; font-weight: 600"
        @click="createCalendarBookMark()"
      >
        <span class="mdi mdi-plus"></span>
      </button>
    </h3>
    <template v-if="calendarBookMarks.length > 0">
      <div v-for="(c, i) in calendarBookMarks" :key="i + '-cbm'">
        <div style="width: 100%; display: flex">
          <p class="member" @click="clickEventFromHistory(c)">
            {{ c.name }}
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <p class="member no-data">お気に入り登録がございません。</p>
    </template>
    <h3 class="menu-title">
      <p>
        <span class="mdi mdi-account-multiple" style="margin-right: 4px"></span>
        最近の予定調整
      </p>
    </h3>
    <template v-if="calendarEventHistory.length > 0">
      <div v-for="(c, i) in calendarEventHistory" :key="i + '-ceh'">
        <div style="width: 100%; display: flex">
          <p class="member" @click="clickEventFromHistory(c)">
            {{ c.name }}
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <p class="member no-data">日程調整履歴がございません。</p>
    </template>
    <h3 class="menu-title">
      <p>
        <span class="mdi mdi-calendar" style="margin-right: 4px"></span>
        マイカレンダー
      </p>
    </h3>
    <template v-if="users.length > 0 && usersStatusAPI.length > 0">
      <template v-for="(u, i) in showUsers">
        <div class="my-calendar" :key="i + '-users'" v-if="u.user_hash === user.userHash">
          <CalendarAPIStatus
            :user="u"
            :selfUser="user"
            :calendarSettings="calendarSettings"
            :default="true"
            :usersStatusAPI="getUsersStatus(u)"
            @changeShowEvent="changeShowEvent"
            @changeShowEventSelf="changeShowEventSelf"
            @createCalendarSettings="createCalendarSettings"
          />
          <div style="width: calc(100% - 48px); display: flex">
            <p
              class="member"
              :class="{ '-pointer': isEditableCalendarSettings(u) }"
              style="padding-left: 8px"
              @click="ucsEditClick(u)"
            >
              <span class="user-color-indicator" :style="getUserColorIndicatorStyle(u.user_hash)"></span>
              <Tooltip :message="u.email">
                <span style="margin-left: 4px; margin-right: 8px">{{ u.username }}</span>
              </Tooltip>
            </p>
          </div>
        </div>
      </template>
    </template>
    <template v-if="users.length > 0 && usersStatusAPI.length > 0">
      <template v-for="(u, i) in showUsers">
        <div class="my-calendar" :key="i + '-users'" v-if="u.user_hash != user.userHash">
          <CalendarAPIStatus
            :user="u"
            :selfUser="user"
            :calendarSettings="calendarSettings"
            :default="true"
            :usersStatusAPI="getUsersStatus(u)"
            @changeShowEvent="changeShowEvent"
            @changeShowEventSelf="changeShowEventSelf"
            @createCalendarSettings="createCalendarSettings"
          />
          <div style="width: calc(100% - 48px); display: flex">
            <p
              class="member"
              :class="{ '-pointer': isEditableCalendarSettings(u) }"
              style="padding-left: 8px"
              @click="ucsEditClick(u)"
            >
              <span class="user-color-indicator" :style="getUserColorIndicatorStyle(u.user_hash)"></span>
              <Tooltip :message="u.email">
                <span style="margin-left: 4px; margin-right: 8px">{{ u.username }}</span>
              </Tooltip>
            </p>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <p class="member no-data">カレンダー登録がございません。</p>
    </template>
  </div>
</template>

<script>
import CalendarAPIStatus from '@/views/DashBoard/Calendar/CalendarAPIStatus'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import { getUserColorIndicatorStyle } from '@/functions/balloonFunc'
import colorList from '@/assets/json/master/color.json'

export default {
  components: {
    CalendarAPIStatus,
    Tooltip,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
    usersStatusAPI: {
      type: Array,
      required: true,
    },
    calendarSettings: {
      type: Array,
      required: true,
    },
    calendarBookMarks: {
      type: Array,
      required: true,
    },
    calendarEventHistory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isSelfCheck: true,
      width: 250,
      beforeMouseX: 0,
    }
  },
  mounted() {
    document.addEventListener('mouseup', this.mouseUp)
    document.addEventListener('mousemove', this.mouseMove)
  },
  beforeDestroy() {
    document.removeEventListener('mouseup', this.mouseUp)
    document.removeEventListener('mousemove', this.mouseMove)
  },
  computed: {
    showUsers () {
        // カレンダー関連で使用する場合はログイン不可ユーザーを表示しない
        return this.users.filter(user => {return user.permission < 3})
    },
  },
  methods: {
    changeShowEvent(cs) {
      this.$emit('changeShowEvent', cs)
    },
    // 自分の予定は保存しない, ON/OFF切り替えのみ
    changeShowEventSelf() {
      this.isSelfCheck = !this.isSelfCheck
      this.$emit('changeShowEventSelf', this.isSelfCheck)
    },
    isEditableCalendarSettings(u) {
      for (const cs of this.calendarSettings) {
        if (u.user_hash === cs.calendar_user) {
          return true
        }
      }
      return false
    },
    ucsEditClick(u) {
      this.$emit('ucsEditClick', u)
    },
    createCalendarBookMark(info) {
      this.$emit('createCalendarBookMark', info)
    },
    clickEventFromHistory(h) {
      this.$emit('clickEventFromHistory', h)
    },
    createCalendarSettings(data) {
      this.$emit('createCalendarSettings', data)
    },
    mouseUp(event) {
      this.beforeMouseX = 0
      this.isMove = false
      event.preventDefault()
    },
    mouseDown(event) {
      this.beforeMouseX = 0
      this.isMove = true
      event.preventDefault()
    },
    mouseMove(event) {
      if (!this.isMove) return
      let page_width = document.documentElement.clientWidth
      let moveX = page_width - event.pageX
      if (moveX > 32 && moveX < page_width - 900) this.width = moveX
      event.preventDefault()
    },
    getUsersStatus(u) {
      for (let us of this.usersStatusAPI) {
        if (u.user_hash === us.user_hash) {
          return us
        }
      }
    },
    getUserColorIndicatorStyle(userHash) {
      // Only pass selfUserHash when getting color for the logged-in user themselves
      const selfUserHash = userHash === this.user.userHash ? this.user.userHash : null
      return getUserColorIndicatorStyle(userHash, this.calendarSettings, colorList, selfUserHash)
    },
  },
}
</script>

<style lang="scss" scoped>
.main-menu {
  position: relative;
  height: 100vh;
  background: #fefefe;
  -webkit-box-shadow: -2px 0px 4px -1px rgba(0, 0, 0, 0.31);
  -moz-box-shadow: -2px 0px 4px -1px rgba(0, 0, 0, 0.31);
  box-shadow: -2px 0px 4px -1px rgba(0, 0, 0, 0.31);
  flex-shrink: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  resize: horizontal;
  .resize-border {
    width: 12px;
    height: 100%;
    position: absolute;
    background: transparent;
    left: 0;
    top: 0;
    cursor: grab;
    z-index: 2;
  }
}
.main-menu > .menu-title {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    white-space: nowrap;
  }
}
.main-body {
  height: calc(100vh - 80px);
  width: calc(100% - 250px);
  overflow: auto;
  position: relative;
}
.main-body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  visibility: hidden;
}
.member {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
  padding-left: 24px;
}
.-pointer {
  cursor: pointer;
}
.member:hover {
  background-color: rgba(240, 200, 200, 0.8);
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 10px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.calendar-view {
  padding: 24px;
  margin: 0 auto;
  max-width: 900px;
  height: calc(100% - 200px);
}
.drawer-menu {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 40%;
  min-width: 400px;
  background: #fefefe;
  padding: 16px;
  z-index: 201;
}
.drawer-back {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 200;
  top: 0;
}
.right-enter-active,
.right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter,
.right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.my-calendar {
  display: flex;
  margin: 4px;
  padding-left: 16px;
}
.no-data {
  font-size: smaller;
  color: #666;
  white-space: nowrap;
}

.user-color-indicator {
  flex-shrink: 0;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/CalendarSideMenu.vue